import {
    formatCheckedAgo,
    type ProviderProfileV2,
    UpcomingLittersRow,
} from "@/features/providers";
import {
    AdoptedDogCards,
    adoptedCardsWithPhotos,
} from "../RecentlyAdoptedSection";
import type { ProviderDogListingCard } from "../provider-listing-card";
import { NO_PUPPIES_LABEL } from "./AvailablePuppiesSection";

export function NothingListedSection({
    adoptedCards,
    profile,
}: {
    adoptedCards: ProviderDogListingCard[];
    profile: ProviderProfileV2 | null | undefined;
}) {
    const availability = profile?.availability;
    const checked =
        availability &&
        formatCheckedAgo(availability.lastCheckedAt, "relative");
    const withPhotos = adoptedCardsWithPhotos(adoptedCards);
    return (
        <section className="w-full">
            <h2 className="text-section-title text-doberman-black text-pretty md:text-balance">
                {withPhotos.length > 0
                    ? "Their recent puppies"
                    : "Available puppies"}
            </h2>
            <div className="mt-2">
                <p className="text-body-small text-doberman-black/45 tabular-nums">
                    {[NO_PUPPIES_LABEL, checked].filter(Boolean).join(" · ")}
                </p>
                {availability && (
                    <UpcomingLittersRow
                        litters={availability.upcomingLitters}
                        className="mt-3"
                    />
                )}
            </div>
            {withPhotos.length > 0 && (
                <AdoptedDogCards cards={withPhotos} className="mt-5" />
            )}
        </section>
    );
}
